import { render, staticRenderFns } from "./ShockGenMetal.vue?vue&type=template&id=b47752e8&scoped=true&"
import script from "./ShockGenMetal.vue?vue&type=script&lang=js&"
export * from "./ShockGenMetal.vue?vue&type=script&lang=js&"
import style0 from "./ShockGenMetal.vue?vue&type=style&index=0&id=b47752e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b47752e8",
  null
  
)

export default component.exports